import * as ReactDOM from 'react-dom';
import React, { useState, useEffect } from 'react';
import './modal.sass';
import 'rodal/lib/rodal.css';
import Rodal from 'rodal';

export const Modal = ({isOpen = false, title, children, setVisible, width, height}) => {

  const [_isOpen, setIsOpen] = useState(isOpen);

  useEffect(() => {
    setIsOpen(isOpen);
  }, [isOpen]);

  const bodyElement = document.querySelector('body');

  const customStyles = {
    wrapper: {
        borderRadius: '24px'
    }
  };

  const handleClose = () => {
      setVisible(false);
  };

  const render = () => {

    return (
        <div>
            <Rodal customStyles={customStyles.wrapper} visible={_isOpen} onClose={handleClose} width={width} height={height} duration={150}>
                <div className='vv-modal'>
                    <h2>{title}</h2>
                    <div>{React.cloneElement(children)}</div>
                </div>
            </Rodal>
        </div>
    );
  };

  return (
    ReactDOM.createPortal(render(), bodyElement)
  );
};
